export default __webpack_public_path__ + "static/media/BOD Regular Meeting December 14, 2020.de63f6a2.pdf";